import { getRemoteValueEnv } from "../setup";

const normalizarUrl = (url) => {
  try {
    const { pathname } = new URL(url);
    return pathname.replace(/\/+$/, "") || "/";
  } catch (error) {
    return null;
  }
};

export const urlDaCampanhaCorresponde = (campanha) => {
  if (!campanha?.url) return false;

  const urlCampanha = normalizarUrl(campanha.url);
  const urlAtual = normalizarUrl(window.location.href);

  return Boolean(urlCampanha) && urlCampanha === urlAtual;
};

export const getCampanhaDesconto = () => {
  try {
    const raw = getRemoteValueEnv(
      "descontoTaxa_dev",
      "descontoTaxa_prod",
    ).asString();

    if (!raw) return null;

    const campanha = JSON.parse(raw);

    if (!campanha || !campanha.desconto) return null;

    if (!urlDaCampanhaCorresponde(campanha)) return null;

    return campanha;
  } catch (error) {
    return null;
  }
};

export default getCampanhaDesconto;
